<template>
  <ErrorBoundary>
    <TeaserSlider
      v-if="(!mgnlProps.isRecommendation)"
      :product-categories="categories"
      :product-c-t-a-target-mode="mgnlProps.productCTATargetMode"
      :image-load-type="(imageLoadType as HTMLImageElement['loading'])"
      :operator="mgnlProps.operator"
      :by-attributes="attributes"
      :data-ab-id="mgnlProps?.dataABId"
    />
    <RecoSliderWrapper
      v-else
    />
  </ErrorBoundary>
</template>

<script lang="ts" setup>
import RecoSliderWrapper from './RecoSliderWrapper.vue';
import { TeaserSliderBuilder, WrapperProps } from './TeaserSlider.model';
import TeaserSlider from './TeaserSlider.vue';

const props = defineProps(WrapperProps);
const mgnlProps = computed(() => TeaserSliderBuilder.build(props));
const productAttributes = await JSON.parse(mgnlProps.value.productAttributes ?? '[]')?.reduce(

  (acc: any, curr: any) => {
    if (!curr.name) {
      return acc;
    }

    if (acc[curr.name]) {
      acc[curr.name].push(curr.value);
      return acc;
    }

    return {
      ...acc,
      [curr.name]: curr.value,
    };
  },
  {} as Record<string, any>,
) || {};

const attributes = {
  ...productAttributes,
  sale: props.sale ?? false,
  recent: props.new ?? false,
  mykik: props.mykik ?? false,
};

const categories: string[]
  = mgnlProps.value.productCategories?.map((product) => {
    let result;

    try {
      result = JSON.parse(product)?.categoryId;
    }
    catch {
      // ignore error
    }

    return result;
  })
    ?.filter(Boolean) ?? [];

const { imageLoadType } = toRefs(props);
provide('imageLoadType', imageLoadType?.value ?? 'lazy');
</script>
